export default __webpack_public_path__ + "static/media/arras07.ef0453be.jpg";